
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plans/platform-checkout",
      function () {
        return require("private-next-pages/plans/platform-checkout/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plans/platform-checkout"])
      });
    }
  